import {ApolloClient, gql} from "@apollo/client";
import {ContestStoreFragment} from "../graphql/fragments";
import {Contest} from "./Submission";
import {action, makeObservable, observable} from "mobx";
import {ContestStore} from "./ContestStore";

export class MobxContestStore implements ContestStore {

  contests: Contest[] = []

  constructor(contests: Contest[]) {
    this.contests = contests
    makeObservable(this, {contests: observable, setContests: action})
  }

  setContests(c: Contest[]) {
    this.contests = c;
  }

  getContest(id: string): Contest {
    return this.contests.find(c => c.id === id)
  }

  static createNew(client: ApolloClient<any>): Promise<ContestStore> {
    return client.query({
      query: query,
    })
      .then(x => x.data.listContests.items)
      .then(contests => contests.map(contest => {

        return ({
          id: contest.id,
          year: contest.year,
          categories: contest.categories.items.map(category => {
            return ({
              id: category.category.id,
              name: category.category.displayName,
              description: category.category.description,
              workTypes: category.category.workTypes.items.map(w => ({
                id: w.workType.id,
                maxCount: w.workType.maxCount,
                maxLengthMinutes: w.workType.maxLengthMinutes,
                name: w.workType.name,
                content: w.workType.content,
                description: w.workType.description
              }))
            });
          })
        });
      })).then(c => new MobxContestStore(c))
  }

}

export const listContests = gql`
  ${ContestStoreFragment}
  query ListContests(
    $filter: ModelContestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
         ...ContestStoreFragment
      }
    }
  }
`;

const query = gql`${ContestStoreFragment}${listContests}`
